import React from 'react'
import PropTypes from 'prop-types'

import SnapToZoomLevelButton from './snaptozoomlevelbutton/SnapToZoomLevelButton'
import './Controls.scss'
import { hasBoardBoardSupport } from '../../../utils/userPermissions'

const Controls = props => {
  const showBoardBoardButton = hasBoardBoardSupport(props.terminalId)
  return (
    <div className="planning-controls">
      <div className="zoom controls-wrapper">
        <span className="header">Zoom</span>

        <div className="controls">
          <div className="control" onClick={props.onChangeTerminalPlannerExpanded}>
            <i
              className={`fas ${props.terminalPlannerExpanded ? 'fa-compress-alt' : 'fa-expand-alt'} custom`}
              aria-hidden="true"
              title="Expand view"
            />
          </div>

          <div className="control" onClick={() => props.onChangeZoom(0.5)}>
            <i className="fa fa-search-plus custom" aria-hidden="true" title="Zoom in" />
          </div>

          <div className="control" onClick={() => props.onChangeZoom(1.5)}>
            <i className="fa fa-search-minus custom" aria-hidden="true" title="Zoom out" />
          </div>
        </div>
      </div>

      <div className="snapping controls-wrapper">
        <span className="header">Snap To Start Of</span>
        <div className="controls">
          {['shift', 'day', 'week', 'month'].map(zoomLevel => {
            return (
              <SnapToZoomLevelButton
                key={zoomLevel}
                zoomLevel={zoomLevel}
                onSnapToZoomLevel={props.onSnapToZoomLevel}
              />
            )
          })}
        </div>
      </div>

      {props.showActions ? (
        <React.Fragment>
          <div className="actions controls-wrapper">
            <span className="header">Actions</span>
            <div className="controls">
              <div
                className={`control  ${props.amountOfUndoStates === 0 ? 'inactive' : ''}`}
                onClick={props.onUndoLastAction}
              >
                <i className={`fa fa-undo custom`} aria-hidden="true" title="Undo" />
              </div>

              <div
                className={`control ${props.amountOfRedoStates === 0 ? 'inactive' : ''}`}
                onClick={props.onRedoLastAction}
              >
                <i className={`fa fa-redo  custom `} aria-hidden="true" title="Redo" />
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : null}

      <div className="view controls-wrapper">
        <span className="header">View</span>
        <div className="controls">
          <div
            className={`control laycan ${props.laycanActive ? ' active' : ''}`}
            onClick={() => props.onToggleAllLaycansOverlay('laycans')}
            title="Toggle show laycans"
          >
            <span className="label">Show Laycan</span>
          </div>
          {showBoardBoardButton && (
            <div
              className={`control board-board ${props.filterBoardBoard ? ' active' : ''}`}
              onClick={() => props.onToggleFilterBoardBoard()}
              title="Toggle hide board board visits"
            >
              <span className="label">Hide board board</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

Controls.propTypes = {
  config: PropTypes.object.isRequired,
  terminalPlannerExpanded: PropTypes.bool.isRequired,
  onChangeTerminalPlannerExpanded: PropTypes.func.isRequired,
  onChangeZoom: PropTypes.func.isRequired,
  onSnapToZoomLevel: PropTypes.func.isRequired,
  amountOfUndoStates: PropTypes.number.isRequired,
  amountOfRedoStates: PropTypes.number.isRequired,
  onUndoLastAction: PropTypes.func.isRequired,
  onRedoLastAction: PropTypes.func.isRequired,
  onToggleAllLaycansOverlay: PropTypes.func.isRequired,
  onToggleFilterBoardBoard: PropTypes.func.isRequired,
  showActions: PropTypes.bool.isRequired,
  laycanActive: PropTypes.bool.isRequired,
  filterBoardBoard: PropTypes.bool.isRequired,
  terminalId: PropTypes.string.isRequired
}

export default Controls
